import { useEffect, useState, useCallback } from 'react';
import * as permissionsApi from 'src/apis/permissions';

/**
 * Get all existing permissions for each existing role in the application (PDM, TA, ...).
 * @returns {{}}
 */
function usePermission() {
    const [ permissions, setPermissions ] = useState({});

    const setup = useCallback(async () => {
        const response = await permissionsApi.list();
        setPermissions(response.data.result);
    }, [ setPermissions ]);

    useEffect(() => {
        setup();
    }, [ setup ]);

    return permissions;
}

export default usePermission;
